import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts/Default";
import EmptySVG from "../images/illustrations/empty_state.svg";
import Button from "../components/buttons/Button";
import Text from "../components/typography/Text";

export default ({ location }) => {
  const currentPath = window.location.pathname;

  return (
    <Layout title="Please sign up">
      <div className="p401">
        <div className="p401_content">
          <img src={EmptySVG} alt="Empty" />
          <h4>You need to sign up to see the projects.</h4>
          <Link to="/signup">
            <Button arrowRight rounded big>
              Sign up
            </Button>
          </Link>
          <Text>
            Already have an account?{" "}
            <Link to={"/login/?redirect_url=" + currentPath}>Log in</Link> now.
          </Text>
        </div>
      </div>
    </Layout>
  );
};
